<template>

  <div class="app-container" v-if="canList">
    <div class="filter-container">
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="订单ID"-->
<!--                v-model="listQuery.entity.mallReward.orderId">-->
<!--      </el-input>-->
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="订单编号"
                v-model="listQuery.entity.mallReward.orderNo">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="收益人"
                v-model="listQuery.entity.mallReward.toUserId">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="收益人名字"
                v-model="listQuery.entity.mallReward.toName">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="收益人编号"
                v-model="listQuery.entity.mallReward.toCode">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="下单人"
                v-model="listQuery.entity.mallReward.name">
      </el-input>
      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                placeholder="下单人编号"
                v-model="listQuery.entity.mallReward.code">
      </el-input>
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="下单人头像"-->
<!--                v-model="listQuery.entity.mallReward.avatar">-->
<!--      </el-input>-->
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="上级信息"-->
<!--                v-model="listQuery.entity.mallReward.topName">-->
<!--      </el-input>-->
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="上级编号"-->
<!--                v-model="listQuery.entity.mallReward.topCode">-->
<!--      </el-input>-->
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="类型"-->
<!--                v-model="listQuery.entity.mallReward.type">-->
<!--      </el-input>-->
<!--      <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                placeholder="详情"-->
<!--                v-model="listQuery.entity.mallReward.info">-->
<!--      </el-input>-->
      <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                 v-model="listQuery.entity.mallReward.status"
                 placeholder="状态">
        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
        </el-option>
      </el-select>
      <el-date-picker
          @change='handleFilter'
          value-format="yyyy-MM-dd HH:mm:ss"
          class="filter-item input"
          v-model="listQuery.entity.mallReward.orderTimes"
          type="datetimerange"
          range-separator="至"
          start-placeholder="下单时间开始日期"
          end-placeholder="下单时间结束日期">
      </el-date-picker>
      <el-date-picker
          @change='handleFilter'
          value-format="yyyy-MM-dd HH:mm:ss"
          class="filter-item input"
          v-model="listQuery.entity.mallReward.doneTimes"
          type="datetimerange"
          range-separator="至"
          start-placeholder="到账时间开始日期"
          end-placeholder="到账时间结束日期">
      </el-date-picker>

      <div style="display: inline-block">

        <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                   @click="handleFilter">查找
        </el-button>
        <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                   v-if="canSave" icon="el-icon-edit">添加
        </el-button>
        <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                   @click="handleDownload">导出
        </el-button>
        <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-upload2"
                   @click="()=>$refs.file.click()">导入
        </el-button>

        <input style="display: none" ref="file" @change="upload" type="file">
      </div>
    </div>

    <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
              style="width: 100%;">
<!--      <yf-table-column align="center" label="ID">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ scope.row.mallReward.id }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
<!--      <yf-table-column align="center" label="订单ID">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.orderId }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
      <yf-table-column align="center" label="订单编号">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.orderNo }}</span>
        </template>
      </yf-table-column>
<!--      <yf-table-column align="center" label="收益人">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.toUserId }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
      <yf-table-column align="center" label="收益人名字">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.toName }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="收益人编号">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.toCode }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="收益">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.amount }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="下单人">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.name }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="下单人编号">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.code }}</span>
        </template>
      </yf-table-column>
<!--      <yf-table-column align="center" label="下单人头像">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.avatar }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
<!--      <yf-table-column align="center" label="上级信息">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.topName }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
<!--      <yf-table-column align="center" label="上级编号">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.topCode }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
<!--      <yf-table-column align="center" label="类型">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.type }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
<!--      <yf-table-column align="center" label="详情">-->
<!--        <template slot-scope="scope">-->
<!--          <span v-if="scope.row.mallReward">{{ scope.row.mallReward.info }}</span>-->
<!--        </template>-->
<!--      </yf-table-column>-->
      <yf-table-column align="center" label="状态">
        <template slot-scope="scope">
                                                <span v-if="scope.row.mallReward">

                         <el-tag :type="tagTypes[scope.row.mallReward.status]" v-if="scope.row.mallReward.status!=null">     {{ statusOptions[scope.row.mallReward.status] }}</el-tag>

                        </span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="下单时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ parseTime(scope.row.mallReward.orderTime) }}</span>
        </template>
      </yf-table-column>
      <yf-table-column align="center" label="到账时间" width="160">
        <template slot-scope="scope">
          <span v-if="scope.row.mallReward">{{ parseTime(scope.row.mallReward.doneTime) }}</span>
        </template>
      </yf-table-column>

      <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
          <el-button v-if="canSave" size="mini" type="danger"
                     @click="handleDelete(scope)">删除
          </el-button>
        </template>
      </yf-table-column>

    </el-table>

    <div class="pagination-container" style="margin-top: 20px">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
               style='width: 450px; margin-left:50px;'>
<!--        <el-form-item label="订单ID" prop="mallReward.orderId">-->
<!--          <el-input v-model="temp.mallReward.orderId"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="订单编号" prop="mallReward.orderNo">
          <el-input v-model="temp.mallReward.orderNo"></el-input>
        </el-form-item>
<!--        <el-form-item label="收益人" prop="mallReward.toUserId">-->
<!--          <el-input v-model="temp.mallReward.toUserId"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="收益人名字" prop="mallReward.toName">
          <el-input v-model="temp.mallReward.toName"></el-input>
        </el-form-item>
        <el-form-item label="收益人编号" prop="mallReward.toCode">
          <el-input v-model="temp.mallReward.toCode"></el-input>
        </el-form-item>
        <el-form-item label="下单人" prop="mallReward.name">
          <el-input v-model="temp.mallReward.name"></el-input>
        </el-form-item>
        <el-form-item label="下单人编号" prop="mallReward.code">
          <el-input v-model="temp.mallReward.code"></el-input>
        </el-form-item>
<!--        <el-form-item label="下单人头像" prop="mallReward.avatar">-->
<!--          <el-input v-model="temp.mallReward.avatar"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="上级信息" prop="mallReward.topName">-->
<!--          <el-input v-model="temp.mallReward.topName"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="上级编号" prop="mallReward.topCode">-->
<!--          <el-input v-model="temp.mallReward.topCode"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="类型" prop="mallReward.type">-->
<!--          <el-input v-model="temp.mallReward.type"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="详情" prop="mallReward.info">-->
<!--          <el-input v-model="temp.mallReward.info"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="状态" prop="mallReward.status">
          <el-select class="filter-item" v-model="temp.mallReward.status" placeholder="状态">
            <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间" prop="mallReward.orderTime">
          <el-date-picker v-model="temp.mallReward.orderTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="下单时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="到账时间" prop="mallReward.doneTime">
          <el-date-picker v-model="temp.mallReward.doneTime" type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss" placeholder="到账时间">
          </el-date-picker>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogForm">取消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
        <el-button v-else type="primary" @click="updateData">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style type="stylus">
.filter-container {
  /*padding-bottom: 20px;*/
}

.filter-item {
  margin-bottom: 10px;
}

.filter-item.input {
  /*line-height: 60px*/
  margin-right: 10px;
}
</style>

<script>
import {list, options, down, upload, info, save, update, remove} from '@/api/mall_reward'
import waves from '@/directive/waves' // 水波纹指令
import {downExcel} from '@/utils/down.js'
import {parseTime} from '@/utils'


import {mapGetters} from 'vuex'
import {hasAuth} from '@/utils/auth'

export default {
  name: 'test',
  directives: {
    waves
  },
  components: {},
  data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      orderTime: null
      ,
      doneTime: null
      ,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'mallReward.id desc',
        entity: {
          mallReward:
              {
                id: null,
                orderId: null,
                orderNo: null,
                toUserId: null,
                toName: null,
                toCode: null,
                name: null,
                code: null,
                avatar: null,
                topName: null,
                topCode: null,
                type: null,
                status: null,
                orderTime: null,
                doneTime: null,
                info: null
              }
        }
      },
      statusOptions: [],
      tagTypes: ['info', '', 'warning', 'danger', 'warning'],
      temp: {

        mallReward:
            {
              id: null,
              orderId: null,
              orderNo: null,
              toUserId: null,
              toName: null,
              toCode: null,
              name: null,
              code: null,
              avatar: null,
              topName: null,
              topCode: null,
              type: null,
              status: null,
              orderTime: null,
              doneTime: null,
              info: null
            }


      }
      ,
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      rules:
          {
            'mallReward.orderId': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.orderNo': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.toUserId': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.toName': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.toCode': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.name': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.code': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.avatar': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.topName': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.topCode': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.type': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.status': [
              {
                required: false,
                message: '必填字段',
                trigger: 'blur'
              }
            ]
            ,
            'mallReward.orderTime': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.doneTime': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
            ,
            'mallReward.info': [
              {
                required: false,
                message: '必填字段',
                trigger: 'change'
              }
            ]
          }
      ,
      downloadLoading: false,
      qData:
          {
            token: '',
            key: ''
          }
    }
  },
  created() {
    this.getList()
    this.getOptions()
  },
  computed: {
    ...mapGetters([
      'perms'
    ]),
    canSave() {
      return hasAuth(this.perms, 'mall:reward:save')
    },
    canDelete() {
      return hasAuth(this.perms, 'mall:reward:delete')
    },
    canUpdate() {
      return hasAuth(this.perms, 'mall:reward:update')
    },
    canList() {
      return hasAuth(this.perms, 'mall:reward:list')
    }
  },
  methods: {
    parseTime(time) {
      if (!time) return ''
      return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
    },
    getList() {
      this.listLoading = true
      list(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    getOptions() {
      options().then(res => {
        this.statusOptions = res.data.statusOptions
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      row.status = status
    },
    beforeFormShow(row) {
      this.resetTemp(row) // 更新数据
    },
    afterFormShow(row) {

    },
    beforeFormCommit() {

    },
    resetTemp(row) {
      this.temp = {
        mallReward: {}
      }
      if (row) {
        this.temp = Object.assign({}, row) // copy obj
      }

    },
    handleCreate() {
      this.beforeFormShow()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.afterFormShow()
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(scope) {
      this.index = scope.$index
      // this.beforeFormShow(scope.row)
      // this.temp = Object.assign({}, row) // copy obj
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
        this.deleteData()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '删除失败'
        })
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              save(this.temp).then(res => {
                this.temp = res.data
                // this.list.unshift(this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    deleteData() {
      // const ids = [this.temp.mallReward.id]
      const ids = [this.list[this.index].mallReward.id]
      remove({ids: ids}).then(res => {
        // 从当前队列中移除
        this.list.splice(this.index, 1)
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleUpdate(scope) {
      this.beforeFormShow(scope.row)
      info(scope.row.mallReward.id).then(res => {
        this.temp = res.data
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              update(this.temp).then(() => {
                // this.list.splice(this.index, 1, this.temp)
                this.getList()
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    closeDialogForm() {
      this.dialogFormVisible = false
    },
    upload(e) {
      upload(e.target.files[0]).then(res => {
        this.$notify({
          title: '成功',
          message: '上传成功!',
          type: 'success',
          duration: 2000
        })
        this.getList()
      })
    },
    handleDownload() {
      this.downloadLoading = true
      down(this.listQuery).then(res => {
        downExcel(res)
        this.downloadLoading = false
        this.$notify({
          title: '成功',
          message: '下载成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // formatJson(filterVal, jsonData) {
    //     return jsonData.map(v => filterVal.map(j => {
    //         return v[j]
    //     }
    // ))
    // },
  }
}
</script>
